module.exports = __webpack_public_path__ + "static/green_check-c1b74d1ed8ee8c441663a99cf89eb275.png";